import { FormTypesNotifications } from 'models/configurator';
import { INotificationReportSettings } from 'models/response';
import * as Yup from 'yup';
import { parserfrequency } from '../utils';

export interface FormValues {
  enabled: boolean;
  selectedFolder: {
    label: string;
    value: string;
  };
  selectedReport: {
    label: string;
    value: string;
  };
  selectedReportFilter: {
    label: string;
    value: string;
  };

  hour: { label: string; value: string } | null;
  minute: { label: string; value: number } | null;
  allDays: boolean;
  daysOfWeek: { label: string; value: number }[];
}

export const defaultValues: FormValues = {
  enabled: false,
  selectedFolder: { label: '', value: '' },
  selectedReport: { label: '', value: '' },
  selectedReportFilter: { label: '', value: '' },
  hour: null,
  minute: null,
  allDays: false,
  daysOfWeek: [],
};

export const validationLogic = (t: (key: string) => string, formMode: string | null) => {
  return Yup.object({
    selectedReportFilter:
      formMode === 'add'
        ? Yup.object()
            .shape({
              label: Yup.string().required(t('required')),
              value: Yup.string().required(t('required')),
            })
            .required(t('required'))
        : Yup.mixed().notRequired(),
    hour: Yup.object()
      .shape({
        label: Yup.string().required(t('required')),
        value: Yup.number().required(t('required')),
      })
      .required(t('required')),
    minute: Yup.object()
      .shape({
        label: Yup.string().required(t('required')),
        value: Yup.number().required(t('required')),
      })
      .required(t('required')),
    allDays: Yup.boolean(),
    daysOfWeek: Yup.array()
      .of(
        Yup.object().shape({
          label: Yup.string().required(),
          value: Yup.number().required(),
        }),
      )
      .test('valid-days', t('required_days_of_week'), function (daysOfWeek) {
        const { allDays } = this.parent;
        if (!allDays && (!daysOfWeek || daysOfWeek.length === 0)) {
          return this.createError({ path: 'daysOfWeek', message: t('required_days_of_week') });
        }
        return true;
      }),
  });
};
export const setInitialValues = (
  selectedRow: INotificationReportSettings | null,
  formMode: FormTypesNotifications,
  t: (key: string) => string,
): FormValues => {
  if (selectedRow && formMode === 'edit') {
    const { enabled, cronFrequency, idFolder, folderName, idReport, reportName, filterName, idUserReportSetting } =
      selectedRow;

    const { validHour, validMinute, allDays, daysOfWeek } = parserfrequency(cronFrequency, t);

    return {
      enabled: enabled,
      selectedFolder: { label: folderName, value: idFolder.toString() },
      selectedReport: { label: reportName, value: idReport.toString() },
      selectedReportFilter: { label: filterName, value: idUserReportSetting.toString() },
      hour: validHour,
      minute: validMinute,
      allDays,
      daysOfWeek,
    };
  }

  return defaultValues;
};
